import Text from 'components/Text/Text';
import React, { useContext, useEffect, useRef } from 'react';
import { IGetSubCategoriesShort, IGetSubCategoriesArguments } from 'types';
import { Select } from 'antd';
import { useFetchData } from 'hooks/useFetchData';
import { getSubCategoriesShortInfoV2 } from 'backend/subcategories';
import { useTranslation } from 'react-i18next';
import {
	ChangeDishPositionContext,
	IChangeDishPositionContext,
} from '../../../../../changeDishPositionState/changeDishPositionContext';
import SelectDropdownReloader from 'components/SelectDropdownReloader/SelectDropdownReloader';
import style from './SubCategorySelect.module.scss';

const { Option } = Select;

export const SubCategorySelect: React.FC = () => {
	const { setIDSubCategory, IDSelectedCategory, IDSelectedSubCategory } =
		useContext<IChangeDishPositionContext>(ChangeDishPositionContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch, responseError } = useFetchData<
		IGetSubCategoriesShort,
		IGetSubCategoriesArguments
	>(IDSelectedCategory ? getSubCategoriesShortInfoV2 : null, {
		categoryId: IDSelectedCategory ? IDSelectedCategory : '',
	});
	const { t } = useTranslation('listing');

	useEffect(() => {
		refetch();
	}, [IDSelectedCategory]);

	return (
		<div className={style.container}>
			<Text translationNameSpace="listing" translationKey="subcategoryLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setIDSubCategory}
				value={IDSelectedSubCategory}
				loading={loading}
				listItemHeight={response?.data.subCategories.length}
				allowClear={true}
				disabled={!IDSelectedCategory || loading}
				notFoundContent={responseError ? <SelectDropdownReloader onReload={refetch} /> : undefined}
				showSearch={true}
				filterOption={(inputValue, option) =>
					option?.children ? String(option.children).toLowerCase().includes(inputValue.toLowerCase()) : false
				}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder={t('selectPlaceholder')}>
				{response?.data.subCategories.length ? (
					<>
						<Option className={style.disabledItem} value="empty" disabled={true}>
							<Text
								translationNameSpace="listing"
								translationKey="selectAnyItemPlaceholder"
								asFragment={true}
							/>
						</Option>
						{response?.data.subCategories.map((el) => (
							<Option className={style.listItem} value={el.id} key={el.id}>
								{el.name}
							</Option>
						))}
					</>
				) : null}
			</Select>
		</div>
	);
};
